import { useRef, useState } from "react";
import useCustomEffect from "./useCustomEffect";

function useScannerListener(listener = (value) => {}) {
  const bufferRef = useRef("");
  const bufferResetRef = useRef(null);
  const [scanValue, setScanValue] = useState(null);

  /**
   * This effect will call the listener when the scan value is set
   */
  useCustomEffect(() => {
    if (scanValue) {
      listener(scanValue);
      setScanValue(null);
    }
  }, [scanValue]);

  /**
   * This effect will add the keydown event listener
   */
  useCustomEffect(() => {
    document.addEventListener("keypress", onKeyPress);
    return () => {
      document.removeEventListener("keypress", onKeyPress);
    };
  });

  /**
   * this method will handle the keydown event
   * @param {event} event
   */
  function onKeyPress(event) {
    if (event.key === "Enter" && bufferRef.current.length > 0) {
      //The scan is handled by the listener, so don't let the enter submit a form as well
      event.preventDefault();
      setScanValue(bufferRef.current);
      clearResetTimer();
      bufferRef.current = "";
    } else {
      bufferRef.current += event.key;
      startResetTimer();
    }
  }

  /**
   * This method will start the reset timer (needed to avoid normal keyboard input as scanner input)
   */
  function startResetTimer() {
    clearResetTimer();
    bufferResetRef.current = setTimeout(() => {
      bufferRef.current = "";
    }, 50);
  }

  /**
   * This method will clear the reset timer
   */
  function clearResetTimer() {
    clearTimeout(bufferResetRef.current);
  }
}

export default useScannerListener;
